export default function ReferenceSections() {
  return {
    restrict: 'E',
    template: require('./reference-sections.html'),
    scope: {
      sections: '<',
      permissions: '<',
      policyDocumentId: '<',
    },
    controller: 'ReferenceSectionsController',
    controllerAs: 'referenceSectionsVM',
    bindToController: true,
    replace: true
  };
}
